// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"CardList_card-wrapper__m0STy"};